import { EnhancerOptions } from "redux-devtools-extension";

/* Record keys from src/react-app-env.d.ts:5 */
const enhancerOptionsList: Record<"production" | "development" | "test", EnhancerOptions> = {
  "production": {},
  "test": {},
  "development": {
    trace: true,
  },
};

export default enhancerOptionsList[process.env.NODE_ENV] || {};
